import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import vollbildBrueckeLegen from './modules/dailyme/web/VollbildBruecke';

/* Muss vor dem ersten Zeichnen stehen: der Player fragt die Namen ab, sobald
   der Vollbildknopf gedrueckt wird — die Bruecke muss dann schon liegen. */
vollbildBrueckeLegen();

ReactDOM.render(
  <App />,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
